// extracted by mini-css-extract-plugin
export default {"saveButton":"createCompanyForm_saveButton__Cs2lu","select":"createCompanyForm_select__lbdJZ"};